import React from "react";
import { truncate } from "lodash";

import Button from "Button";

const DiscountListView = ({
  discounts,
  gratuities = [],
  quickAddDiscount,
  quickAddGratuity,
  isModifyingOrder,
}) => {
  return (
    <div className="StoreMenu">
      {discounts.length === 0 ? (
        <p className="has-text-centered">No discounts available.</p>
      ) : (
        <div className="py-2">
          <h3 className="title is-size-4 mb-2">Available Discounts</h3>

          <div className="flex-table">
            {discounts.map((discount, i) => {
              const { active } = discount;
              return (
                <div key={"disc" + i} className={`flex-table-item`}>
                  <span
                    className={`is-absolute p-2 has-background-success`}
                  />
                  <h5
                    className="flex-table-cell is-size-5"
                  >
                    {truncate(discount.name, 50)}
                  </h5>
                  <div
                    className="flex-table-cell"
                  >
                    {discount.discountUnit === "percent"
                      ? `${discount.discountAmount}%`
                      : `$${discount.discountAmount}`}
                  </div>
                  <div className="flex-table-cell is-flex-grow-0 mr-6">
                  </div>
                  <div className="flex-table-cell cell-end is-flex-grow-0">
                    <Button
                      text="Quick Add"
                      disabled={!active}
                      loading={isModifyingOrder}
                      className="ml-auto"
                      onClick={() => quickAddDiscount(discount.id)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {gratuities.length > 0 && (
        <div className="py-2">
          <h3 className="title is-size-4 mb-2">Available Gratuities</h3>

          <div className="flex-table">
            {gratuities.map((gratuity, i) => {
              const { active } = gratuity;
              return (
                <div key={"grat" + i} className={`flex-table-item`}>
                  <span className={`is-absolute p-2 has-background-info`} />
                  <h5 className="flex-table-cell is-size-5">
                    {truncate(gratuity.name, 50)}
                  </h5>
                  <div className="flex-table-cell">
                    {gratuity.gratuityUnit === "percent"
                      ? `${gratuity.gratuityAmount}%`
                      : `$${gratuity.gratuityAmount}`}
                  </div>
                  <div className="flex-table-cell is-flex-grow-0 mr-6"></div>
                  <div className="flex-table-cell cell-end is-flex-grow-0">
                    <Button
                      text="Quick Add"
                      disabled={!active}
                      loading={isModifyingOrder}
                      className="ml-auto"
                      onClick={() => quickAddGratuity(gratuity.id)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscountListView;
